import React, { useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useRegion } from "../../../context/RegionContext";
import SEOMetadata from "../../../components/SEOMetadata";
import { seoConfig } from "../../../config/seoConfig";

import { getBlogSummaries } from "../../../services/blogService";
import HomeIcon from "../../../assets/svg/HomeIcon.svg";
import RightSideArrow from "../../../assets/svg/RightSideArrow.svg";

const NzBlogDetail = () => {
    const { slug } = useParams();
    const { region } = useRegion();
    const navigate = useNavigate();
    const [blog, setBlog] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        getBlogSummaries(region)
            .then(data => {
                const foundBlog = data.find(b => b.WPTextBlockId.toString() === slug);
                if (foundBlog) {
                    setBlog(foundBlog);
                } else {
                    navigate("/nz/blog");
                }
                setLoading(false);
            })
            .catch(err => {
                console.error("Error fetching blog detail:", err);
                setLoading(false);
                navigate("/nz/blog");
            });
        window.scrollTo(0, 0);
    }, [slug, region, navigate]);


    const seoData = seoConfig.nz.blogDetail;

    if (loading) return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <div className="loader"></div>
        </div>
    );
    if (!blog) return null;

    const displayData = {
        title: blog.TextBlockTitle || blog.TextBlockName,
        content: blog.TextBlockContent,
        author: blog.ChangeUserName || "Tuatara Team",
        date: new Date(blog.ChangeDateTime).toLocaleDateString('en-NZ', { day: 'numeric', month: 'long', year: 'numeric' }),
        excerpt: blog.TextBlockShortContent,
        image: blog.Pictures?.[0]?.url
    };

    return (
        <div className="min-h-screen">

            <SEOMetadata
                title={displayData.title}
                description={displayData.excerpt}
                keywords={`${seoData.keywords}, ${displayData.title}`}
            />

            {/* Breadcrumb Section */}
            <div className="px-[12px] py-[6px] bg-[#F0F0F0] flex items-center">
                <img
                    src={HomeIcon}
                    alt="HomeIcon"
                    className="cursor-pointer"
                    onClick={() => navigate(`/${region}/blog`)}
                />
                <div className="flex items-center mx-[5px]">
                    <img src={RightSideArrow} alt="RightSideArrow" />
                    <img src={RightSideArrow} alt="RightSideArrow" />
                </div>
                <div className="text-[14px] leading-[24px] text-[#383838] montserrat-semi-bold">
                    Blog Details
                </div>
            </div>

            {/* Hero Section */}
            <div className="relative w-full overflow-hidden bg-black/5 flex items-center justify-center h-[40vh] sm:h-[50vh] md:h-[60vh] lg:h-[70vh]">
                <img
                    src={displayData.image}
                    alt={displayData.title}
                    className="w-full h-full object-contain"
                />
                <div className="absolute inset-0  pointer-events-none"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="custom-container text-center max-w-5xl">
                        {/* <div className="mb-6">
                            <span className="bg-[#7ABF5B] text-white text-sm font-bold px-4 py-2 rounded-full uppercase tracking-widest">
                                {displayData.author}
                            </span>
                        </div>
                        <h1 className="kuunari-bold text-4xl md:text-6xl lg:text-7xl text-white mb-6 uppercase leading-tight" style={{ textShadow: "2px 4px 10px rgba(0,0,0,0.5)" }}>
                            {displayData.title}
                        </h1>
                        <div className="text-gray-200 montserrat-regular text-lg">
                            {displayData.date}
                        </div> */}
                    </div>
                </div>
            </div>

            {/* Content Section */}
            <div className="bg-white py-6 lg:py-6">
                <div className="custom-container">
                    <div className="max-w-5xl mx-auto">


                        <div className="bg-white p-6 md:p-12 lg:p-16 rounded-3xl shadow-xl border border-[#eee]">

                            <h1 className="kuunari-bold text-3xl md:text-5xl lg:text-6xl text-[#1a1a1a] mb-6 md:mb-8 uppercase leading-tight">
                                {displayData.title}
                            </h1>
                            <div className="mb-6" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <span className="text-[#7ABF5B] font-bold text-sm tracking-widest uppercase">
                                    By {displayData.author}
                                </span>
                                <div className="text-gray-500 montserrat-regular text-sm font-medium">
                                    {displayData.date}
                                </div>
                            </div>

                            {displayData.excerpt && (
                                <p className="text-gray-600 montserrat-regular text-base md:text-lg leading-relaxed mb-6">
                                    {displayData.excerpt}
                                </p>
                            )}

                            <hr className="border-gray-100 mb-10" />

                            <div className="blog-content-container">
                                <style dangerouslySetInnerHTML={{ __html: `
                                    .blog-content h2 {
                                        font-family: 'Kuunari-Bold', sans-serif;
                                        font-size: 2rem;
                                        color: #1a1a1a;
                                        margin-top: 2.5rem;
                                        margin-bottom: 1.25rem;
                                        text-transform: uppercase;
                                        letter-spacing: 0.025em;
                                        line-height: 1.2;
                                    }
                                    .blog-content p {
                                        margin-bottom: 1.5rem;
                                        color: #4a4a4a;
                                        line-height: 1.8;
                                    }
                                    .blog-content ul {
                                        margin-bottom: 2rem;
                                        padding-left: 1.5rem;
                                        list-style-type: disc;
                                    }
                                    .blog-content li {
                                        margin-bottom: 0.75rem;
                                        color: #4a4a4a;
                                    }
                                    .blog-content a {
                                        color: #7ABF5B;
                                        text-decoration: underline;
                                        font-weight: 600;
                                        transition: color 0.3s;
                                    }
                                    .blog-content a:hover {
                                        color: #5f9a46;
                                    }
                                    .blog-content .blog-float-right {
                                        float: right;
                                        width: 45%;
                                        margin: 0 0 15px 20px;
                                        border-radius: 8px;
                                    }
                                    @media (max-width: 768px) {
                                        .blog-content h2 {
                                            font-size: 1.5rem;
                                        }
                                        .blog-content .blog-float-right {
                                            float: none;
                                            width: 100%;
                                            margin: 15px 0;
                                        }
                                    }
                                `}} />
                                <div
                                    className="blog-content font-[Montserrat] text-gray-700 text-lg md:text-xl leading-relaxed space-y-8"
                                    dangerouslySetInnerHTML={{ __html: displayData.content }}
                                />
                            </div>

                            {/* <div className="mt-16 pt-8 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-6">
                                <div className="text-gray-400 text-sm font-medium tracking-wide">
                                    SHARE THIS ARTICLE
                                </div>
                                <div className="flex gap-4">
                                    <button className="w-10 h-10 rounded-full border border-gray-200 text-gray-600 flex items-center justify-center hover:bg-[#7ABF5B] hover:border-[#7ABF5B] hover:text-white transition-all duration-300">
                                        <i className="fab fa-facebook-f"></i>
                                    </button>
                                    <button className="w-10 h-10 rounded-full border border-gray-200 text-gray-600 flex items-center justify-center hover:bg-[#7ABF5B] hover:border-[#7ABF5B] hover:text-white transition-all duration-300">
                                        <i className="fab fa-twitter"></i>
                                    </button>
                                    <button className="w-10 h-10 rounded-full border border-gray-200 text-gray-600 flex items-center justify-center hover:bg-[#7ABF5B] hover:border-[#7ABF5B] hover:text-white transition-all duration-300">
                                        <i className="fas fa-link"></i>
                                    </button>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>

            {/* Related Posts Section can be added here */}
        </div>
    );
};

export default NzBlogDetail;
